<app-loader></app-loader>

<ngx-toast></ngx-toast>
<router-outlet ></router-outlet>

<app-mail-status-popup></app-mail-status-popup>
